import type { ProductPageData } from "~/routes/product-details/loader/product-detail-loader";

/**
 * Returns the PDP loader payload from a `useMatches()` entry, or `undefined`
 * when the match is not a PDP route. Owns the catch-all dispatcher's wrap
 * shape (`{ type: 'pdp', seo, pageType, data }` — see the `type: "pdp"` `data()`
 * call in the `$.tsx` loader) so consumers can read PDP fields with one
 * accessor instead of re-implementing the traversal. Refactoring the wrap will
 * fail here at compile time, surfacing breakage to every caller.
 *
 * COM-174: this accessor deliberately lives OUTSIDE `routes/$.tsx`. It is
 * imported by `root.tsx`, and a static `root -> routes/$` import welds the
 * entire catch-all component graph (PDP, PLP, Builder blocks, swiper) into
 * the shared chunk every page loads. Only the type import above (erased at
 * build time) may reference PDP modules from here.
 */
export const pdpDataFromMatch = (match: {
  data?: unknown;
}): ProductPageData | undefined => {
  const d = match.data as { type?: string; data?: ProductPageData } | undefined;
  return d?.type === "pdp" ? d.data : undefined;
};
